import React from 'react';
import LegalPageLayout from 'features/legal/components/LegalPageLayout/LegalPageLayout';

// Template content pending legal review — required now to support Twilio A2P campaign
// registration for Bagel AI's SMS/MMS number; the SMS section's disclosures are mandatory
// for that review (non-sharing of mobile numbers, message frequency, rates-may-apply, opt-out).
function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" updatedOn="August 21, 2026">
      <p>
        URBAN TXT: Teens Exploring Technology (&quot;URBAN TXT&quot;, &quot;we&quot;, &quot;us&quot;)
        respects your privacy. This policy explains what information we collect, how we use it,
        and your choices — including for our SMS/MMS text messaging service.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We collect information you provide directly, such as your name, email address, and mobile
        phone number, when you register for a program, contact us, or text our SMS number. We also
        collect the content of messages you send us and basic delivery metadata (timestamps,
        message status) for our records.
      </p>

      <h2>SMS/MMS Text Messaging</h2>
      <p>
        By providing your mobile phone number and opting in, you consent to receive text messages
        from URBAN TXT, including from our Bagel AI assistant.
      </p>
      <ul>
        <li>
          <strong>
            We do not share, sell, or provide your mobile phone number or messaging consent data to
            third parties or affiliates for marketing or promotional purposes.
          </strong>{' '}
          Your mobile phone number and SMS opt-in data are used solely to communicate with you.
        </li>
        <li>
          <strong>Message frequency varies</strong> based on your interactions with us — for
          example, program updates or your conversation with Bagel AI. You will not receive
          recurring messages beyond what your interactions generate.
        </li>
        <li>
          <strong>Message and data rates may apply.</strong> Check with your mobile carrier for
          details on your plan.
        </li>
        <li>
          Reply <strong>STOP</strong> at any time to opt out of further messages. Reply{' '}
          <strong>HELP</strong> for assistance. You can also contact us using the information
          below.
        </li>
      </ul>

      <h2>How We Use Information</h2>
      <p>
        We use the information we collect to operate our programs, respond to your messages,
        improve our services, and — where you&apos;ve opted in — to assist you through Bagel AI
        (for example, building or updating a website you&apos;ve requested). Images or files you
        send us are stored securely and used only for the purpose you sent them for.
      </p>

      <h2>How We Protect Your Information</h2>
      <p>
        We use reasonable administrative, technical, and physical safeguards to protect the
        information we collect. Access is limited to staff and systems that need it to provide our
        services.
      </p>

      <h2>Your Choices</h2>
      <p>
        You may opt out of SMS messages at any time by replying STOP. You may request access to,
        correction of, or deletion of your personal information by contacting us below.
      </p>

      <h2>Contact Us</h2>
      <p>
        Questions about this policy? Contact URBAN TXT at{' '}
        <a href="mailto:privacy@urbantxt.org">privacy@urbantxt.org</a>.
      </p>
    </LegalPageLayout>
  );
}

export default PrivacyPolicy;
